<template>
  <v-container fluid class="px-0 py-0">
    <v-card
        v-if="!!aggregateStore"
        :height="height || componentHeight"
    >
      <slot name="bar">
        <v-system-bar height="24">
          <v-btn
              v-if="!state.modalDialog"
              icon
              :to="{name: parentComponent}"
              width="10"
              height="10"
              class="mt-1 mx-2"
          >
            <v-icon color="blue-grey lighten-1" small>mdi-table-arrow-left</v-icon>
          </v-btn>
          <slot name="bar.left">
            <BaseStatusIcon
                v-if="!!currentItem && !!currentItem.row_statuses"
                :value="currentItem.row_statuses"
                :small="true"></BaseStatusIcon>
          </slot>
          <!--          {{ title }}-->
          <v-spacer></v-spacer>
          <slot name="bar.middle"></slot>
          <CommonQR v-if="!!currentItem && !!currentItem.qrcode" :value="currentItem.qrcode" :text="currentItem.qrcode"></CommonQR>
          <v-chip small v-if="!!currentItem">uid: {{ currentItem.uid }}</v-chip>
          <v-chip small v-if="!!currentItem">{{ $t('version') }}: {{ version }}</v-chip>
          <v-chip v-if="!!aggregateStore" small>buffer length: {{ Object.keys(aggregateStore.uid_dict).length }}
          </v-chip>
          <v-chip
              small
              v-if="!!currentItem && !!currentItem.created_by_uid && !!aggregateStore.rootData[currentItem.created_by_uid]"
          >
            {{ $t('created_by') }}:
            {{ aggregateStore.rootData[currentItem.created_by_uid].username }}
          </v-chip>
          <v-chip small v-if="!!currentItem && !!currentItem.created_on">
            {{ currentItem.created_on | moment("DD.MM.YY HH:mm") }}
          </v-chip>
          <v-chip
              small
              v-if="!!currentItem && !!currentItem.edited_by_uid && !!aggregateStore.rootData[currentItem.edited_by_uid]"
          >
            {{ $t('edited_by') }}:
            {{ aggregateStore.rootData[currentItem.edited_by_uid].username }}
          </v-chip>
          <v-chip small v-if="!!currentItem && !!currentItem.edited_on">{{
              currentItem.edited_on | moment("DD.MM.YY HH:mm")
            }}
          </v-chip>
          <CommonRefresh :loading="state.loading" @click="update()"></CommonRefresh>
          <CommonIsSaved
              small
              v-if="!!currentItem"
              class="ml-3"
              :value="currentItem.is_saved"
          ></CommonIsSaved>
          <v-spacer></v-spacer>
          <BaseDeleteIcon
              v-if="!!currentItem"
              v-model="currentItem.deleted"
              :readonly="false"
              :show_label="false"
          ></BaseDeleteIcon>
          <v-btn
              v-if="!!wrapComponent && state.modalDialog && !!state.uidItem && !disableFullScreen"
              icon small
              :to="{ name: wrapComponent, params: { uidItem: state.uidItem }}"
          >
            <v-icon small>mdi-fullscreen</v-icon>
          </v-btn>
          <CommonBarMenu
              v-if="!!currentItem && !!state.common && !!state.common.bar_actions && state.common.bar_actions.length > 0"
              v-model="state.common.bar_menu"
              :modal-dialog="state.modalDialog"
              :is-new="currentItem.pk === null"
              @action="onAction($event)"
              @embedded_close="onClose()"
              @embedded_restore="onRestore()"
              @alternate_action="$emit('alternate_action', $event)"
          ></CommonBarMenu>
        </v-system-bar>
      </slot>
      <slot name="body" v-if="!!currentItem" :height="height || componentHeight"></slot>
      <slot name="body.alt" :enableRootData="!!currentItem" :height="height || componentHeight">{{ '' }}</slot>
    </v-card>
    <slot name="action">
      <v-toolbar height="36" class="mb-auto">
        <CommonTaskIcon :source_uid="state.uidItem" :small="false"></CommonTaskIcon>
        <CommonBtnActionGroup
            v-if="!!currentItem && !!state.common && !!state.common.bar_actions && state.common.bar_actions.length > 0"
            v-model="state.common.bar_actions"
            :modal-dialog="state.modalDialog"
            :is-new="!currentItem.pk"
            @action="onAction($event)"
            @embedded_action="$emit('embedded_action', $event)"
            @embedded_close="onClose()"
            @alternate_action="$emit('alternate_action', $event)"
            :disabled="task_running"
        ></CommonBtnActionGroup>
      </v-toolbar>
    </slot>
    <v-dialog
        v-model="state.dialogRestore"
        scrollable
        persistent
        v-if="!!currentItem && !!currentItem.pk"
    >
      <CoreChangeLogTable
          :store-name="storeCoreLogName"
          :height="this.$vuetify.breakpoint.height * 0.90 - 150"
          @embedded_close="state.dialogRestore = false"
      ></CoreChangeLogTable>
    </v-dialog>
  </v-container>

</template>

<script>
import Vue from 'vue'
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {defineStore} from "pinia";
import {debounce} from "debounce";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import CommonRefresh from "@/components/Common/CommonRefresh";
import CommonBtnActionGroup from "@/components/Common/CommonBtnActionGroup";
import CommonToolbar from "@/components/Common/CommonToolbar";
import CommonIsSaved from "@/components/Common/CommonIsSaved";
import BaseStatusIcon from "@/components/Base/BaseStatusIcon";
import {v4 as uuidv4} from "uuid";
import moment from "moment";
import CommonBarMenu from "@/components/Common/CommonBarMenu";
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTaskIcon from "@/components/Common/CommonTaskIcon";
import CommonQR from "@/components/Common/CommonQR.vue";

export const useDetailStore = function (storeName) {
  let aggregateStore = useAggregateStore()
  return defineStore(storeName, {
        state: () => ({
          uidItem: null,
          parentUid: null,
          dialogDetail: false,
          dialogRestore: false,
          modalDialog: false,
          loading: false,
          enableClose: true,
          enableSave: true,
          common: {},
          metadata: null,
          dtoDetailQuery: null,
          defaultNewItem: null,
          width: null,
        }),
        getters: {},
        actions: {
          callReceive() {
            this.loading = false
          },
          callBack() {
            this.metadata = null
          },
          // create() {
          //   aggregateStore.fetchValidate(
          //       {uidItems: [this.uidItem], create: true, parentUid: this.parentUid})
          //   this.dialogDetail = false
          // },
          update() {
            // console.log('state.update', storeName, this.dtoDetailQuery)
            this.loading = true
            aggregateStore.fetchItem({
              storeName: storeName,
              dtoDetailQuery: this.dtoDetailQuery,
              uidItem: this.uidItem,
              metadata: this.metadata,
              callBack: this.callBack,
              parentUid: this.parentUid,
            })
          },
          openDetailDialog(item, uid = null) {
            // console.log('defineStore.openDetailDialog', this.defaultNewItem)
            if (!!item || uid) {
              this.uidItem = uid || item.uid
              this.dialogDetail = true
              return
            }
            let newItem = null
            if (!!this.defaultNewItem)
              newItem = this.defaultNewItem()
            else
              newItem = {uid: uuidv4()}
            this.uidItem = newItem.uid
            Vue.set(aggregateStore.rootData, newItem.uid, newItem)
            this.dialogDetail = true
          },
          onAction({actionName, actionUid, data = null, callReceive = null}) {
            aggregateStore.fetchAction({
              storeName: storeName,
              dtoActionCommand: this.dtoActionCommand,
              uidItem: this.uidItem,
              uidSelected: [this.uidItem],
              actionName: actionName,
              actionUid: actionUid,
              data: data,
              callBack: null,
              callReceive: callReceive,
            })
          },
        },
      }
  )
}

export default {
  name: "CommonDetail",

  props: {
    title: null,
    height: {default: null},
    width: {default: null},
    disableFullScreen: {default: false},
    uidItem: {default: null},
    dtoDetailQuery: {type: [String], default: null},
    dtoSaveCommand: {type: [String], default: null},
    dtoValidateCommand: {type: [String], default: null},
    dtoModelForValidate: {type: [String], default: null},
    dtoActionCommand: {type: [String], default: null},
    aggregateName: {type: [String], default: null},
    storeName: {type: [String], default: null},
    mainValidator: {type: [Boolean], default: false},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: null},
    wrapComponent: {type: [String], default: null},
    defaultNewItem: null,
  },

  components: {
    CommonTaskIcon,
    'CoreChangeLogTable': () => import("@/components/CoreChangeLog/CoreChangeLogTable"),
    BaseDeleteIcon,
    CommonRefresh,
    CommonBtnActionGroup,
    CommonToolbar,
    CommonIsSaved,
    BaseStatusIcon,
    CommonBarMenu,
    CommonQR,
  },

  computed: {
    currentItem() {
      if (!!this.aggregateStore && !!this.aggregateStore.rootData && !!this.state && !!this.state.uidItem)
        return this.aggregateStore.rootData[this.state.uidItem]
      else
        return null
    },
    task() {
      if (!!this.currentItem && this.aggregateStore.source_uid_task &&
          this.aggregateStore.source_uid_task[this.state.uidItem])
        return this.aggregateStore.source_uid_task[this.state.uidItem]
      else
        return null
    },
    task_running() {
      if (!!this.task)
        return this.task.state === 'PENDING' || this.task.state === 'STARTED'
      else
        return false
    },
    task_state() {
      if (!!this.task)
        return this.task.state
      else
        return null
    },
    version() {
      let ver = this.currentItem.version
      if (ver > 1000000) {
        ver = Math.round(ver / 1000000).toString()
        return moment.unix(ver).format("DD.MM.YY HH:mm:ss")
      } else
        return ver
    },
    queryParameters() {
      if (!!this.state)
        return this.state.uidItem
    },
    componentHeight() {
      if (this.modalDialog) {
        return this.$vuetify.breakpoint.height * 0.90 - 39
      } else {
        return this.$vuetify.breakpoint.height - 39
      }
    },
  },

  watch: {
    queryParameters: {
      handler(newValue, oldValue) {
        // console.log('watch CommonDetail queryParameters', newValue, oldValue)
        this.update()
        this.coreLogFilter()
      },
      deep: true
    },
    task_state: {
      handler(newValue, oldValue) {
        // console.log('watch CommonDetail queryParameters', newValue, oldValue)
        if (newValue !== oldValue)
          return this.$emit('task', this.task)
      },
      deep: true
    },
  },

  methods: {
    update() {
      // console.log('update', this.state.uidItem, this.items)
      this.state.update()
      // update: debounce(function () {
      //   if (!!this.items)
      //     return
      //   this.state.update()
      // }, 500)
    },
    onAction({actionName, actionUid, data = null, callReceive = null}) {
      this.state.onAction(
          {actionName: actionName, actionUid: actionUid, data: data, callReceive: callReceive})
    },
    onClose() {
      // console.log('onClose CommonDetail')
      this.state.dialogDetail = false
      this.$emit('close')
    },
    onRestore() {
      this.state.dialogRestore = true
      this.$emit('restore')
    },
    coreLogFilter() {
      // console.log('partNumberFilter', this.is_group)
      this.storeCoreLog.filters = this.storeCoreLog.filters.filter(x => x.param_compare !== 'object_uid')
      this.storeCoreLog.filters.push({param_compare: 'object_uid', value: this.state.uidItem})
    },
  },

  setup({storeName, uidItem, modalDialog, dtoDetailQuery, dtoActionCommand, defaultNewItem, width}) {
    // console.log('setup', storeName, uidItem, modalDialog)
    let state = useDetailStore(storeName)()
    state.uidItem = uidItem
    state.modalDialog = modalDialog
    state.dtoDetailQuery = dtoDetailQuery
    state.dtoActionCommand = dtoActionCommand
    state.defaultNewItem = defaultNewItem
    state.width = width
    return {state}
  },

  async mounted() {
    this.aggregateStore = useAggregateStore()
    if (this.mainValidator === true) {
      this.aggregateStore.dtoValidateCommand = this.dtoValidateCommand
      this.aggregateStore.validateUidItem = this.uidItem
      this.aggregateStore.dtoModelForValidate = this.dtoModelForValidate
    }
    if (!!this.state.uidItem)
      this.state.update()
    // console.log('mount Detail', this, this.uidItem, this.state)
    this.storeCoreLog = useTableStore(this.storeCoreLogName)()
    this.coreLogFilter()
  },

  data() {
    return {
      aggregateStore: null,
      storeCoreLog: null,
      storeCoreLogName: uuidv4(),
    }
  }
}
</script>

<style scoped>

</style>

<i18n src="@/components/Common/locales.json">
</i18n>